/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RejectedTombstoneContainer_comment = {
    readonly id: string;
    readonly " $refType": "RejectedTombstoneContainer_comment";
};
export type RejectedTombstoneContainer_comment$data = RejectedTombstoneContainer_comment;
export type RejectedTombstoneContainer_comment$key = {
    readonly " $data"?: RejectedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"RejectedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '5a52b044795c30dd53dff01d3c2d4095';
export default node;
